export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-gradient/index.js